export default __webpack_public_path__ + "static/get-start-e0ca32b573637621b3a5b14b4fc40661.png";